import { Box, Flex, FloraInput, FloraSelect, FloraSelectItem } from '@grupoboticario/flora-react'

import { FLEXIBLE_POINTS_RULE_LIST } from '@/constants/accelerationTable'

import * as S from '../AccelerationForm.styles'

interface FlexiblePointsProps {
  isReadOnly?: boolean
  pointsType: string
  countOfDays: string
  isDaysCalendarRule: boolean
  onFlexibleRuleChange: (value: string) => void
  onNumberOfDaysChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onCountOfDaysKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const FlexiblePoints = ({
  isReadOnly = false,
  pointsType,
  countOfDays,
  isDaysCalendarRule,
  onFlexibleRuleChange,
  onNumberOfDaysChange,
  onCountOfDaysKeyDown
}: FlexiblePointsProps) => {
  return (
    <Flex direction="column" gap="$3" css={{ marginTop: '$5' }}>
      <Flex gap="$3">
        <Box css={S.fullWidthCss}>
          <FloraInput
            data-testid="flexibleStartInfoInput"
            disabled
            id="flexibleStartInfo"
            label="Início da vigência dos pontos"
            readOnly
            size="medium"
            value="A partir da data de apuração"
          />
        </Box>

        <Box css={S.fullWidthCss}>
          <FloraSelect
            as="div"
            data-testid="pointsFlexibleRuleInput"
            disabled={isReadOnly}
            id="pointsFlexibleRule"
            label="Regra de pontuação"
            onSelected={(selected) => onFlexibleRuleChange(selected?.value ?? '')}
            placeholder="Selecionar"
            required
            size="medium"
            value={pointsType}
          >
            {FLEXIBLE_POINTS_RULE_LIST.map((rule) => (
              <FloraSelectItem key={rule.value} label={rule.label} value={rule.value} />
            ))}
          </FloraSelect>
        </Box>
      </Flex>

      {isDaysCalendarRule && (
        <Box css={S.fullWidthCss}>
          <FloraInput
            data-testid="countOfDaysInput"
            disabled={isReadOnly}
            id="countOfDays"
            label="Quantidade de dias corridos"
            min="1"
            onChange={onNumberOfDaysChange}
            onKeyDown={onCountOfDaysKeyDown}
            readOnly={isReadOnly}
            required
            size="medium"
            step="1"
            type="number"
            value={countOfDays}
          />
        </Box>
      )}
    </Flex>
  )
}

export default FlexiblePoints
